const AnnouncementFormSection = ({ title, children }) => {
  return (
    <div className="announcement-form-section">
      {title && (
        <h3 className="FP_Body_Semibold black">{title}</h3>
      )}
      {children}
    </div>
  );
};

export default AnnouncementFormSection;
